import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

import { TreeFlatNode } from '../../models/tree.model'

export type KeyboardTemplateDragState = {
  active: boolean
  sourceNode: TreeFlatNode | null
  destinationFocusRequestId: number
  inDestination: boolean
}

@Injectable({ providedIn: 'root' })
export class KeyboardTemplateDragService {
  private readonly _state$ = new BehaviorSubject<KeyboardTemplateDragState>({
    active: false,
    sourceNode: null,
    destinationFocusRequestId: 0,
    inDestination: false,
  })

  readonly state$ = this._state$.asObservable()

  get snapshot(): KeyboardTemplateDragState {
    return this._state$.getValue()
  }

  start(sourceNode: TreeFlatNode) {
    const prev = this._state$.getValue()
    this._state$.next({
      active: true,
      sourceNode,
      destinationFocusRequestId: prev.destinationFocusRequestId,
      inDestination: false,
    })
  }

  cancel() {
    const prev = this._state$.getValue()
    this._state$.next({
      active: false,
      sourceNode: null,
      destinationFocusRequestId: prev.destinationFocusRequestId + 1,
      inDestination: false,
    })
  }

  requestDestinationFocus() {
    const prev = this._state$.getValue()
    if (!prev.active) {
      return
    }
    this._state$.next({
      ...prev,
      destinationFocusRequestId: prev.destinationFocusRequestId + 1,
      inDestination: true,
    })
  }
}
